"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _clearEcommerceObject() {
    /**
     * It's recommended that you use the following command to clear the ecommerce object prior to pushing an ecommerce event to the data layer.
     * Clearing the object will prevent multiple ecommerce events on a page from affecting each other.
     */
    pushDataLayer({ ga4_ecommerce: null });
}
function pushDataLayer(obj, options) {
    if (options === void 0) { options = {}; }
    if (options.clearEcommerceObject)
        _clearEcommerceObject();
    if (!window.ocm.dataLayerHelper)
        return;
    window.ocm.dataLayerHelper.push(obj);
}
exports.default = pushDataLayer;
